import service from '~api/compact';
import * as types from '../types';

export default {
  getCompactList({ commit }, payload) {
    return service.apiGetCompactList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_LIST, res.data);
      }
    });
  },
  getCompactCount({ commit }, payload) {
    return service.apiGetCompactCount(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_COUNT, res.data);
      }
    });
  },
  getCompactTypeList({ commit }, payload) {
    return service.apiGetCategoryData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_TYPE_LIST, res.data);
      }
    });
  },
  getSigningFormList({ commit }, payload) {
    return service.apiGetCategoryData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_SIGNING_FORM_LIST, res.data.results);
      }
    });
  },
  getServiceContentList({ commit }, payload) {
    return service.apiGetCategoryData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_SERVICE_CONTENT_LIST, res.data);
      }
    });
  },
  getSettlementTypeList({ commit }, payload) {
    return service.apiGetCategoryData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_SETTLEMENT_TYPE_LIST, res.data);
      }
    });
  },
  busiSelectSearch({ commit }, payload) {
    return service.apiGetBusiSelectData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_SELECT_DATA, res.data);
      }
    });
  },
  customSelectSearch({ commit }, payload) {
    return service.apiGetCustomSelectData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_CUSTOM_SELECT_DATA, res.data);
      }
    });
  },
  saveAddCompact({ commit }, payload) {
    return service.apiSaveAddCompact(payload);
  },
  deleteCompact({ commit }, payload) {
    return service.apiDeleteCompact(payload);
  },
  getCompactDetail({ commit }, payload) {
    return service.apiGetCompactDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_DETAIL, res.data);
      }
    });
  },
  updateCompact({ commit }, payload) {
    return service.apiUpdateCompact(payload);
  },
  getReturndRecord({ commit }, payload) {
    return service.apiQueryList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_RETURND_RECORD, res.data);
      }
    });
  },
  // 回款列表 - 删除记录
  deletePaybackRecord({ commit }, payload) {
    return service.apiDeletePayback(payload)
  },  
  deleteReturnRecord({ commit }, payload) {
    return service.apiDeleteReturnRecord(payload);
  },
  saveAddReturn({ commit }, payload) {
    return service.apiSaveAddReturnRecord(payload);
  },
  saveUpdateReturn({ commit }, payload) {
    return service.apiSaveUpdateReturnRecord(payload);
  },
  getReturndRecordDetail({ commit }, payload) {
    return service.apiGetReturndRecordDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_RETURND_RECORD_DETAIL, res.data);
      }
    });
  },
  // 发票
  getBillsRecord({ commit }, payload) {
    return service.apiGetBillsRecord(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_BILLS_RECORD, res.data);
      }
    });
  },
  deleteBillsRecord({ commit }, payload) {
    return service.apiDeleteBillsRecord(payload);
  },
  saveAddBills({ commit }, payload) {
    return service.apiSaveAddBillsRecord(payload);
  },
  saveUpdateBills({ commit }, payload) {
    return service.apiSaveUpdateBillsRecord(payload);
  },
  getBillsRecordDetail({ commit }, payload) {
    return service.apiGetBillsRecordDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_BILLS_RECORD_DETAIL, res.data);
      }
    });
  },
  getCompactFileList({ commit }, payload) {
    return service.apiGetCompactFileList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_FILE_LIST, res.data);
      }
    });
  },
  uploadCompactFile({ commit }, payload) {
    return service.apiUploadCompactFile(payload.params, payload.config);
  },
  deleteCompactFile({ commit }, payload) {
    return service.apiDeleteCompactFile(payload);
  },
  compactExport({ commit }, payload) {
    return service.apiCompactExport(payload.params, payload.config);
  },
  getCompactCostList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      service
        .apiGetCompactCostList(payload)
        .then((res) => {
          if (res.data) {
            commit(types.GET_COMPACT_COST_LIST, res.data);
          }
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getCostType({ commit }, payload) {
    return service.apiGetCostType(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_COST_TYPE, res.data);
      }
    });
  },
  saveAddCompactCost({ commit }, payload) {
    return service.apiSaveAddCompactCost(payload);
  },
  saveUpdateCompactCost({ commit }, payload) {
    return service.apiSaveUpdateCompactCost(payload);
  },
  deleteCompactCost({ commit }, payload) {
    return service.apiDeleteCompactCost(payload);
  },
  getCoprationDepartmentList({ commit }, payload) {
    return service.apiGetCategoryData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COPRATION_DEPARTMENT, res.data);
      }
    });
  },
  // 获取合同管理的团队
  getCompactTeams({ commit }, payload) {
    return service.apiGetCompactTeams(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_TEAM, res.data);
      }
    });
  },
  // 获取业务员下拉菜单
  getCompactSalesman({ commit }, payload) {
    return service.apiGetCompactSalesman(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_SALESMAN, res.data);
      }
    });
  },
  // 获取回款列表数据
  getMoneyBackData({ commit }, payload) {
    return service.apiGetMoneyBackData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_MONEY_BACK_DATA, res.data);
      }
    });
  },
  // 获取成本列表
  getCostDataList({ commit }, payload) {
    return service.apiGetCostDataList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COST_DATA_LIST, res.data);
      }
    });
  },
  // 获取费用列表
  getPayDataList({ commit }, payload) {
    return service.apiGetPayDataList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_PAY_DATA_LIST, res.data);
      }
    });
  },
  getPayType({ commit }, payload) {
    return service.apiGetPayType(payload).then((res) => {
      if (res.data) {
        commit(types.GET_COMPACT_PAY_TYPE, res.data);
      }
    });
  },
  saveAddCompactFee({ commit }, payload) {
    return service.apiSaveAddCompactFee(payload);
  },
  saveUpdateCompactFee({ commit }, payload) {
    return service.apiUpdateCompactFee(payload);
  },
  deleteCompactFee({ commit }, payload) {
    return service.apiDeleteCompactFee(payload);
  },
  // 回款导入
  upload({ commit }, payload) {
    return service.apiUploadBackData(payload.params, payload.config);
  },
  // 成本导入
  uploadCost({ commit }, payload) {
    return service.apiUploadCostData(payload.params, payload.config);
  },
  // 合同回款-删除
  apiMoneyDelete({ commit }, payload) {
    return service.apiMoneyDelete(payload);
  },
  // 合同回款-批量删除
  apiMoneyDeletelist({ commit }, payload) {
    return service.apiMoneyDeletelist(payload);
  },
  // 合同成本-删除
  apiCostDelete({ commit }, payload) {
    return service.apiCostDelete(payload);
  },
  // 合同成本-批量删除
  apiCostDeletelist({ commit }, payload) {
    return service.apiCostDeletelist(payload);
  },
  // 获取支出合同列表数据
  getContractSupport({ commit }, payload) {
    return service.apiContractSupport(payload).then((res) => {
      if (res.data) {
        commit(types.GET_MONEY_SPEND_DATA, res.data);
      }
    });
  },
  // 获取支出合同列表业务员
  getSpendSales({ commit }, payload) {
    return service
      .apiSpendQueryTeam(payload)
      .then((res) => {
        commit(types.GET_SPEND_SALES, res.data);
      })
      .catch(() => {});
  },
  // 支出合同-新增
  addApiSupport({ commit }, payload) {
    return service.apiAddSupport(payload);
  },
  // 支出合同-修改
  updateApiSupport({ commit }, payload) {
    return service.apiUpdateSupport(payload);
  },
  // 支出合同-删除
  deleteApiSupport({ commit }, payload) {
    return service.apiDeleteSupport(payload);
  },
  // 支出合同-导出
  exportApiSupport({ commit }, payload) {
    return service.apiExportSupport(payload);
  },
  // 支出合同-详情
  getDetailApiSupport({ commit }, payload) {
    return service.apiDetailSupport(payload).then((res) => {
      commit(types.GET_SPEND_DETAIL, res.data);
    });
  },
};
